import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Grid from '@mui/material/Grid2';
import { IconButton, styled, Tooltip } from "@mui/material";
import React, { ReactNode } from "react";

type Control = {
  icon: ReactNode;
  onClick: Function;
  color?: "red";
  tooltip: string;
  disabled?: boolean;
};
export type DeviceCardAccordionType = {
  open: boolean;
  onClick: Function;
  permanentControls?: Control[];
  expandedControls?: Control[];
};

export const GridContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1.5),
}));
const Button = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.common.grey.dark,
  "&.Mui-disabled": {
    backgroundColor: theme.palette.common.grey.g5C5C5C,
  },
}));

const DeviceCardAccordion = (
  props: React.PropsWithChildren<DeviceCardAccordionType>
) => {
  const { open, onClick, permanentControls, expandedControls } = props;

  return (
    <GridContainer container flexGrow={open ? 1 : 0} sx={{ width: '100%' }}>
      <Grid
        sx={{
          flexGrow: "1",
          width: "min-content"
        }}>
        <Grid
          container
          direction="column"
          sx={{ width: '100%', height: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
            flex: "1" }}>
          {open && (
            <Grid
              container
              direction="row"
              sx={{ width: '100%', gap: "1rem" }}>
              {expandedControls?.map((control, index) => (
                <Tooltip key={index} arrow title={control.tooltip}>
                  <Button
                    onClick={() => control.onClick()}
                    sx={
                      control.color === "red"
                        ? {
                            backgroundColor: ({ palette }) =>
                              palette.error.dark,
                          }
                        : {}
                    }
                  >
                    {control.icon}
                  </Button>
                </Tooltip>
              ))}
            </Grid>
          )}
          <Grid
            container
            direction="row"
            sx={{ width: '100%', gap: "1rem" }}>
            {permanentControls?.map((control, index) => (
              <Tooltip key={index} arrow title={control.tooltip}>
                <Button
                  onClick={() => control.onClick()}
                  disabled={control.disabled ?? false}
                >
                  {control.icon}
                </Button>
              </Tooltip>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid container direction="column-reverse" sx={{ width: '100%', height: "100%" }}>
          <Button
            disabled={
              expandedControls === undefined || expandedControls.length === 0
            }
            onClick={() => onClick()}
          >
            {open ? <ExpandMore /> : <ExpandLess />}
          </Button>
        </Grid>
      </Grid>
    </GridContainer>
  );
};

export default DeviceCardAccordion;
